import { useEffect, useRef } from 'react';
import Modal from './Modal';

const icons = {
  success: (
    <svg className="h-6 w-6 text-success" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  ),
  error: (
    <svg className="h-6 w-6 text-danger" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12" y2="17" />
    </svg>
  ),
};

const closeButtonStyles =
  'border border-danger bg-transparent text-danger shadow-sm hover:bg-danger-soft focus:ring-danger';

const SuccessDialog = ({
  isOpen,
  title = 'Success',
  message,
  onClose,
  primaryAction,
  variant = 'success',
  zIndexClass,
  /** When set (ms), success dialogs auto-dismiss after this delay. Errors are never auto-closed. */
  autoCloseAfterMs,
}) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen || variant !== 'success' || autoCloseAfterMs == null || autoCloseAfterMs <= 0) {
      return undefined;
    }
    const id = window.setTimeout(() => {
      onCloseRef.current?.();
    }, autoCloseAfterMs);
    return () => window.clearTimeout(id);
  }, [isOpen, variant, autoCloseAfterMs]);

  const icon = icons[variant] ?? icons.success;
  const closeButtonClass = closeButtonStyles;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      zIndexClass={zIndexClass}
      title={title}
      icon={icon}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            className={`inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-surface disabled:cursor-not-allowed disabled:opacity-60 ${closeButtonClass}`}
          >
            Close
          </button>
          {primaryAction ? primaryAction : null}
        </>
      }
    >
      <p className="text-sm text-text-secondary">{message}</p>
    </Modal>
  );
};

export default SuccessDialog;


